import Vue from "vue";
import VueI18n from "vue-i18n";
import fr from "@/i18n/fr";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: "fr",
    fallbackLocale: "fr",
    messages: { fr },
});

// Preload default language
const loadedLanguages = ["fr"];

/**
 * Sets the localization language.
 * @param lang Language identifier
 */
function setI18nLanguage(lang) {
    i18n.locale = lang;
    document.querySelector("html").setAttribute("lang", lang);
    return lang;
}

/**
 * Sets the localization language.
 * The localization module is lazy loaded
 * @param lang Language identifier
 */
function loadLanguageAsync(lang: string): Promise<any> {
    if (i18n.locale !== lang) {
        if (loadedLanguages.indexOf(lang) < 0) {
            // Import the module dynamically if needed
            return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/${lang}`).then(msgs => {
                i18n.setLocaleMessage(lang, msgs.default);
                loadedLanguages.push(lang);
                return setI18nLanguage(lang);
            });
        }

        return Promise.resolve(setI18nLanguage(lang));
    }

    return Promise.resolve(lang);
}

export { i18n, loadLanguageAsync };
